<script>
import DynamicTable from '../../components/DynamicTable.vue'
import DynamicForm from '../../components/DynamicForm.vue'
import Sidebar from '../../components/Sidebar.vue'
import Topbar from '../../components/Topbar.vue'
import toast from '@/methods/toast'
import messages from '@/methods/messages'
import services from '@/http'
import schemaUsers from './schema'
import modelContador from './model'
import { mapState } from 'vuex'
import masks from '@/methods/masks'

export default {
  name: 'Dfes',
  components: {
    DynamicTable,
    Sidebar,
    Topbar,
    DynamicForm
  },
  data () {
    return {
      paginacao: {
        sizeForPages: 30,
        currentPage: 1,
      },
      showForm: false,
      myFields: ['Id', 'Nome', 'CPF/CNPJ', 'Responsável', 'Representante'],
      myFieldsNames: ['id', 'nome', 'cnpj', 'responsavel', 'nome_rep'],
      myData: [],
      filter: {
        nome: '',
        cnpj: '',
        representante: null        
      },
      schema: schemaUsers,
      contadorAtual: {...modelContador},
      representantes: [],
    }
  },
  created () {
    if (this.user.user.tipo === 'D' || this.user.user.tipo === 'A') {
      this.loadTable()
      this.loadRepresentantes()
      this.loadCalback()
    } else {
      this.$router.push('/')
    }
  },
  computed: {
    ...mapState('auth', ['user']),
    cnpfcpfComputed: {
      get: function() {
        return this.filter.cnpj;
      },
      set: function(value) {
        const valueClean = String(value).replace(/[^0-9]+/g,"")
        const newCnpj = masks.maskCpfCnpj(valueClean)
        this.filter.cnpj = masks.maskCpfCnpj(newCnpj)
      }
    }
  },
  methods: {
    clearSelect (filter) {
      this.filter[filter] = null
    },
    filterData(inc) {
      if (inc !== 0)
        this.paginacao.currentPage = this.paginacao.currentPage + inc;
      else
        this.paginacao.currentPage = 1

      this.loadTable()
      window.scrollTo(0, 10)
    },
    loadTable () {
      let action = {
        form: {
          nome: this.filter.nome,
          cnpj: this.filter.cnpj,
          representante: this.filter.representante,
          paginacao: this.paginacao
        }
      }
      services.auth.todosContadores(action)
        .then(res => {
          const usersWs = res.body.contadores
          const newUsers = []
          for (let i = 0; i < usersWs.length; i++) {
            const contadorFor = {
              id: usersWs[i].id,
              cnpj: masks.maskCpfCnpj(usersWs[i].cnpj),
              nome: usersWs[i].nome,
              contato: usersWs[i].contato,
              responsavel: usersWs[i].responsavel,
              representante: usersWs[i].representante,
              nome_rep: usersWs[i].nome_rep
            }
            newUsers.push(contadorFor)
          }
          this.myData = newUsers
        })
        .catch(err => {
          let msg = messages.getMessage(err, 'Falha ao selecionar usuários!')
          toast.toastError(msg)
        })
    },
    loadCalback () {
        schemaUsers.callBackSuccess = function (param) {
          return new Promise((resolve, reject) => {
            services.auth.postContador( {fields: param} ).then(() => {
              toast.toastSuccess('Contador gravado com sucesso!')
              resolve()
            }).catch(res => {
              let msg = messages.getMessage(res, 'Falha ao inserir usuário!')
              toast.toastError(msg)
              reject()
            })
          })
        }
    },
    loadRepresentantes () {
      services.auth.representantes({}).then(res => {
        this.representantes = res.body.representantes.representantes
      })
    },
    setcontadorAtual (paramUser) {
      this.contadorAtual = paramUser
      this.showModal(true)
    },
    showModal (state) {
      for (let iRep = 0; iRep < schemaUsers.fields.length; iRep++) {
        if (schemaUsers.fields[iRep].model === 'representante') {
          schemaUsers.fields[iRep].itens = this.representantes
        }
      }

      this.showForm = state
    },
    addContador () {
      this.contadorAtual = {...modelContador}
      this.showModal(true)
    }
  }
}
</script>

<template>
  <div class="home">
    <Topbar />
    <DynamicForm
      v-bind:schema="schema"
      v-bind:showForm="showForm"
      v-bind:model="contadorAtual"
      v-on:updateStateShowForm="showModal"
    />
    <div id="wrapper">
      <Sidebar />
      <div id="content-wrapper">
        <div class="container-fluid">
          <div class="card mb-3 border-flat">
            <div class="card-body">
                <form class="form-filter">
                  <div class="row">
                    <div class="col-6 col-sm-4 m-left">
                      <label for="filter-nome">Nome</label>
                      <input
                        type="text"
                        class="form-control"
                        placeholder="nome"
                        name="filter-nome"
                        v-model="filter.nome"
                      >
                    </div>

                    <div class="col-6 col-sm-4 m-left">
                      <label for="filter-cnpj">CPF/CNPJ</label>
                      <input
                        type="text"
                        class="form-control"
                        placeholder="CPF/CNPJ"
                        name="filter-cnpj"
                        v-model="cnpfcpfComputed"
                      >
                    </div>

                    <div class="col-6 col-sm-4">          
                      <label class="labels-default" for="item.name">Representante</label>
                      <select
                        class="form-control"
                        name="representante"
                        v-model="filter.representante"
                        v-on:keyup.8="clearSelect('representante')"
                        v-on:keyup.46="clearSelect('representante')"
                      >
                        <option v-for="subitem in representantes" :key="subitem.id" :value="subitem.value">
                          {{subitem.description}}
                        </option>
                      </select>
                    </div>

                  </div>
                  <div class="mt-2 text-right">
                      <button
                        type="button"
                        class="btn bg-blue-dt btn-psq"
                        v-on:click="filterData(0)">
                        Pesquisar
                      </button>
                      <button
                        type="button"
                        class="btn bg-blue-dt btn-psq"
                        v-on:click="addContador">
                        Add
                      </button>
                    </div>
                </form>
            </div>
          </div>
          <DynamicTable
            v-bind:myFields="myFields"
            v-bind:fieldsNames="myFieldsNames"
            v-bind:generalData="myData"
            v-on:setCurrentModel="setcontadorAtual"
          />
        </div>
      </div>
    </div>

    <a class="scroll-to-top rounded" href="#page-top">
      <i class="fas fa-angle-up"></i>
    </a>

    <div class="container">
      <div class="row">
        <div class = "ml-auto">
          <nav aria-label="Navegação de página exemplo" v-if="paginacao.currentPage !== 0">
            <ul class="pagination justify-content-right">
              <li class="page-item" v-if="paginacao.currentPage > 1">
                <a class="page-link pointer-cursor" v-on:click="filterData(-1)">Anterior</a>
              </li>
              <li class="page-item disabled">
                <a class="page-link pointer-cursor" tabindex="-1">{{ parseInt(paginacao.currentPage) }}</a>
              </li>
              <li class="page-item" v-if="myData.length >= paginacao.sizeForPages">
                <a class="page-link pointer-cursor" v-on:click="filterData(+1)">Próximo</a>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </div>

  </div>
</template>

<style scoped>
  .btn-psq{ margin-left: 5px }
  .form-filter{margin-left: 10px;}
</style>
